import { EticketPortalMixer, VoucherV2 } from '@linktivity/eticketportal';

const Language = EticketPortalMixer.Language;
type Language = EticketPortalMixer.Language;

const Country = EticketPortalMixer.Country;
type Country = EticketPortalMixer.Country;

const SubStatusId = EticketPortalMixer.SubStatusId;
type SubStatusId = EticketPortalMixer.SubStatusId;

const TicketTypeId = EticketPortalMixer.TicketTypeId;
type TicketTypeId = EticketPortalMixer.TicketTypeId;

const CodeType = EticketPortalMixer.CodeType;
type CodeType = EticketPortalMixer.CodeType;

const DetailType = EticketPortalMixer.DetailType;
type DetailType = EticketPortalMixer.DetailType;

const SupplierOperation = EticketPortalMixer.SupplierOperation;
type SupplierOperation = EticketPortalMixer.SupplierOperation;

const StatusId = EticketPortalMixer.EticketportalmixerStatusId;
type StatusId = EticketPortalMixer.EticketportalmixerStatusId;

const CouponStatusId = EticketPortalMixer.SelfRedemptionOptionPresetStatusId;
type CouponStatusId = EticketPortalMixer.SelfRedemptionOptionPresetStatusId;

const CheckInCodeId = EticketPortalMixer.CheckInCodeId;
const CheckInCodeValidationId = EticketPortalMixer.CheckInCodeValidationId;

const ETICKET_TITLE = 'eTicket portal';

const VALID_TICKET_STATUSES = [
  StatusId.Usable,
  StatusId.Unused,
  StatusId.InUse
] as const;

type VALID_TICKET_STATUSES = (typeof VALID_TICKET_STATUSES)[number];

const SHOW_TICKET_STATUSES = [
  StatusId.Invalid,
  StatusId.Awaiting,
  StatusId.Used,
  StatusId.Expired,
  StatusId.Distributed,
  StatusId.Returned
] as const;

type SHOW_TICKET_STATUSES = (typeof SHOW_TICKET_STATUSES)[number];

export type ExtendedParticipantFieldId = VoucherV2.ExtendedParticipantFieldId;
export const ExtendedParticipantFieldId = VoucherV2.ExtendedParticipantFieldId;

export type ExtendedBookingFieldId = VoucherV2.ExtendedBookingFieldId;
export const ExtendedBookingFieldId = VoucherV2.ExtendedBookingFieldId;

export type QRCodeGenerateType = VoucherV2.QRCodeGenerateType;
export const QRCodeGenerateType = VoucherV2.QRCodeGenerateType;

export type LanguageV2 = VoucherV2.Language;
export const LanguageV2 = VoucherV2.Language;

export type FileType = VoucherV2.FileType;
export const FileType = VoucherV2.FileType;

export {
  Language,
  Country,
  SubStatusId,
  TicketTypeId,
  CodeType,
  DetailType,
  SupplierOperation,
  StatusId,
  CouponStatusId,
  CheckInCodeId,
  CheckInCodeValidationId,
  ETICKET_TITLE,
  VALID_TICKET_STATUSES,
  SHOW_TICKET_STATUSES
};
